import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'grow-angular/guards';
import { GuestGuard } from './guards/guest.guard';
import { LoginFormComponent } from './pages/login-form/login-form.component';
import { MaintenancePageComponent } from './pages/maintenance-page/maintenance-page.component';

const routes: Routes = [
  {
    path: 'app',
    pathMatch: 'full',
    redirectTo: 'error-page',
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.module').then((m) => m.RegistrationModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'error-page',
    loadChildren: () => import('./pages/error-page/error-page.module').then((m) => m.ErrorPageModule),
  },
  {
    path: '**',
    redirectTo: 'error-page',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
